<template>
    <users-current
        v-slot="{
            data: user
        }"
    >
        <users-update
            :params="{
                user: user.uuid
            }"
            v-slot="{
                sid,
                is_loading: is_saving,
                update,
                error
            }"
            @success="onSuccess"
            @error="onError"
        >
            <div>
                <base-alert
                    v-if="user.email_amend"
                    level="warning"
                    class="mb-6"
                >
                    <template slot="heading">Email change requested</template>

                    <template slot="content">
                        <p>
                            You've already submitted an email change request. Please check your new email ({{ user.email_amend }})
                            for a link to verify it.
                        </p>
                    </template>
                </base-alert>

                <div class="mb-6 bg-white rounded shadow">
                    <header class="flex items-center px-4 border-b h-18 sm:px-6">
                        <h1 class="text-lg font-normal">
                            Update Email
                        </h1>
                    </header>

                    <base-form @submit="update(form)">
                        <div class="px-4 py-3 border-b sm:px-6 md:py-6">
                            <validator-alert :sid="sid" />

                            <form-section>
                                <template slot="title">Email</template>
                                <template slot="description">
                                    What is your new email address?
                                </template>

                                <grid-layout>
                                    <grid-layout-item>
                                        <form-item
                                            :sid="sid"
                                            :is-required="true"
                                            name="email"
                                        >
                                            <template slot="label">Email</template>

                                            <input-text
                                                v-model="form.email"
                                                :sid="sid"
                                                placeholder="you@email.co.uk"
                                                :disabled="is_saving"
                                                name="email"
                                                type="email"
                                            />
                                        </form-item>
                                    </grid-layout-item>
                                </grid-layout>
                            </form-section>
                        </div>

                        <base-form-footer class="rounded-b">
                            <base-button
                                :is-loading="is_saving"
                                type="submit"
                                class="w-full btn-blue md:w-auto"
                            >
                                Update Email
                            </base-button>
                        </base-form-footer>

                        <error-modal
                            v-if="error && $error.is(error, { exclude: [422] })"
                            :error="error"
                        />

                        <modal-success :is-open="show_updated_modal">
                            <template slot="heading">Email updated!</template>

                            <p>To complete your email update, please click the link on the email we've just sent you.</p>

                            <template slot="footer">
                                <div class="flex flex-col md:flex-row-reverse">
                                    <router-link
                                        :to="{
                                            name: $router.fix('dashboard.*.settings.index')
                                        }"
                                        class="text-center btn btn-green"
                                    >
                                        Go to Settings
                                    </router-link>
                                </div>
                            </template>
                        </modal-success>
                    </base-form>
                </div>
            </div>
        </users-update>
    </users-current>
</template>

<script>
    import scroll from '../../../../../support/scroll'
    import UsersCurrent from '../../../../../components/users-current'
    import UsersUpdate from '../../../../../components/users-update'

    export default {
        components: {
            UsersCurrent,
            UsersUpdate
        },
        data () {
            return {
                show_updated_modal: false,
                form: {
                    email: ''
                }
            }
        },
        methods: {
            onSuccess ({ data: user }) {
                setTimeout(() => {
                    this.show_updated_modal = true
                }, 0)
            },
            onError () {
                scroll.toTop()
            }
        }
    }
</script>
